import { RequestBuilder } from "../requestBuilder";
import { GetContextResponseSchema } from "./contextClient.types";

// The server picks the most-specific header (X-Project-Id wins over X-Organization-Id).
export const GetContextRequestConfig = new RequestBuilder({
  path: () => "/context",
  responseSchema: GetContextResponseSchema,
})
  .withIncludeProjectId()
  .withIncludeOrganizationId();
